import React, { useEffect, useState } from "react";
import SupplierDetails from "./SupplierDetails";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";          // 🆕 i18n import
import { useAuth } from "../../contexts/AuthProvider";
import { API_URL } from "../../utils/config";
const baseUrl = API_URL;
const Supplier = () => {
  const { t } = useTranslation("supplier");             // 🆕 namespace
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const { isAuthenticated } = useAuth();
  const [data, setData] = useState({});

  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

  useEffect(() => {
    const fetchSupplier = async () => {
      if (!isAuthenticated) {
        setError(new Error(t("errors.noToken")));        // ⬅️ i18n
        setLoading(false);
        navigate("/login");
        return;
      }

      try {
        
        const supplierResponse = await fetch(
          `${baseUrl}/api/v1/attnd-supplier/suppliers/${id}`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              lang: getLangFromLocalStorage(),

            },
          }
        );

        const Data = await supplierResponse.json();

        if (!supplierResponse.ok) {
          if (supplierResponse.status === 401) {
            navigate("/login");
            throw new Error(t("errors.unauthorized"));   // ⬅️ i18n
          } else if (supplierResponse.status === 404) {
            alert(t("errors.deleted"));                  // ⬅️ i18n
            navigate(-1);
          } else {
            throw new Error(
              `An error occurred: ${Data.error || supplierResponse.statusText}`
            );
          }
        }

        const supplier = Data.data;
        setData({
          name: supplier.name,
          serviceType: supplier.service_type,
          serviceTypeNames: supplier.service_type_names || [],
          country: supplier.country,
          city: supplier.city,
          cityNames: supplier.city_names || [],
          email: supplier.supported_email,
          website: supplier.website,
          about: supplier.about,
          image: supplier.image,
        });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchSupplier();
    } else {
      setLoading(false);
    }
  }, [baseUrl, id, navigate, t]);

  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        {t("errors.fetch")}: {error.message}
      </div>
    );
  }

  return <SupplierDetails supplier={data} />;
};

export default Supplier;
